import React from 'react';
import { connect } from 'react-redux';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';

const MyPaymentCardDetails = (props) => {
    const subTitleStyle = {
        fontSize: '14px',
        fontWeight: 'bold',
        // backgroundColor:'#eceff1',
    };
    const titleStyle = {
        fontSize: '16px',
        fontWeight: 'bold',
    };
    const { companyDefaultPaymentMethod } = props;
    if (companyDefaultPaymentMethod) {
        const { phone, name, email, address } = companyDefaultPaymentMethod.billing_details;
        const { country, postal_code, line1, line2, city } = address;
        const { brand, exp_month, exp_year, funding, last4 } = companyDefaultPaymentMethod.card;
        return (
            <div className="text-left p-4" style={{}} >
                <h5 style={titleStyle}><b>We charge you on this card</b></h5>
                {/* BILLING ADDRESS */}
                <div className="pt-3">
                    <hr />
                    <h5 style={subTitleStyle}>Account details</h5>
                    <hr />
                    <p><b>Account name:</b> {name}</p>
                    <p><b>Billing email:</b> {email}</p>
                    <p><b>Billing phone number:</b> {phone}</p>
                    <p><b>Country:</b> {country}</p>
                    <p><b>City:</b> {city}</p>
                    <p><b>Address:</b> {line1}, {line2}</p>
                    <p><b>Postal or ZIP code:</b> {postal_code}</p>
                </div>

                {/*  CARD */}
                <div className="pt-3">
                    <hr />
                    <h5 style={subTitleStyle}>Card details</h5>
                    <hr />
                    <p><b>Last 4 digits:</b> {last4} <span style={{textTransform: "capitalize"}}>({brand})</span></p>
                    <p><b>Expiry date:</b> {exp_month}/{exp_year}</p>
                    <p><b>Card type:</b> {funding}</p>
                </div>
            </div>
        );
    } else {
        return (
            <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        );
    }
};

const mapStateToProps = (state) => {
    return {
        companyData: state.firestore.data.Company,
        themeColors: state.theme,
        userData: state.firebase.profile,
        userId: state.firebase.auth.uid,
        companyDefaultPaymentMethod: state.firestore.data.PaymentMethod,
    }
}

export default compose(
    connect(mapStateToProps),
    firestoreConnect((props) => {
        var { stripeDefaultPmid, coid } = props.companyData;
        stripeDefaultPmid = stripeDefaultPmid ? stripeDefaultPmid === "" ? "-1" : stripeDefaultPmid : "-1";
        // console.log(stripeDefaultPmid)
        return [
            {
                collection: `PaymentMethods/${coid}/StripePaymentMethods`,
                storeAs: "PaymentMethod",
                doc: stripeDefaultPmid,
            },
        ]
    })
)(MyPaymentCardDetails);